import {ShieldCheck, UserRound} from "lucide-react";
import {Link} from "react-router";
import {useAuthenticatedUser} from "@/auth/AuthHooks.ts";
import {Button} from "@/components/ui/button.tsx";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu.tsx";
import {cn} from "@/lib/utils.ts";

function getInitials(name: string): string {
    return name
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map(part => part.charAt(0))
        .join("")
        .toUpperCase();
}

export default function UserMenu() {
    const user = useAuthenticatedUser();
    const name = user.displayName || user.username;
    const initials = getInitials(name) || <UserRound/>;

    return <DropdownMenu>
        <DropdownMenuTrigger asChild>
            <Button type="button" variant="ghost" size="icon"
                    className={cn("relative m-1 overflow-hidden rounded-full ",
                        "border-2 border-border bg-surface-raised",
                        "hover:border-primary/60 data-[state=open]:border-primary/60",
                        "focus-visible:outline-hidden"
                    )}
                    aria-label={`Benutzermenü für ${name}`}
            >
                <span className="absolute inset-0 flex items-center justify-center text-xs font-semibold"
                      aria-hidden="true">
                    {initials}
                </span>
                {user.pictureUrl &&
                    <img src={user.pictureUrl} alt=""
                         className="relative size-full bg-background object-cover"
                         onError={event => event.currentTarget.hidden = true}
                    />}
            </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-56">
            <DropdownMenuLabel>
                <span className="block">{name}</span>
                <span className="block text-xs font-normal text-muted-foreground">{user.username}</span>
            </DropdownMenuLabel>
            {user.admin && <>
                <DropdownMenuSeparator/>
                <DropdownMenuItem asChild>
                    <Link to="/admin"><ShieldCheck/>Administration</Link>
                </DropdownMenuItem>
            </>}
        </DropdownMenuContent>
    </DropdownMenu>;
}
